// ثوابت الأدوار في النظام
export const ADMIN = 'admin';
export const TEACHER = 'teacher';
export const STUDENT = 'student';
